import React, { useState } from "react";
import { Form, Button, Spinner, Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectApiUrls } from "../../redux/slices/apiUrlSlice";
import { checkoutRecordUrl } from "../../services/checkoutService";
import axiosInstance from "../../axios/axiosConfig";

function AdminManualCheckout({ onJobCheckedOut }) {
  const { generalProject: endpoint } = useSelector(selectApiUrls);
  const [jobId, setJobId] = useState(""); // State to store job ID
  const [assignedUser, setAssignedUser] = useState(""); // State to store assigned user
  const [loading, setLoading] = useState(false); // State to track loading
  const [message, setMessage] = useState(null); // State for success/error message

  // API call to manually check out a job
  const handleManualCheckout = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    const currentDate = new Date().toISOString(); // Get current date

    try {      const response = await axiosInstance.patch(
        checkoutRecordUrl(endpoint, jobId),
        {
          ID: jobId,
          CheckedOutBy: assignedUser,
          CheckedOutDate: currentDate,
          IsCheckedOut: true,
        }
      );

      if (response && response.status === 200) {
        setMessage(`Job ${jobId} successfully checked out by ${assignedUser}`);
        onJobCheckedOut(); // Trigger refresh after successful checkout
        console.log(`Job ${jobId} checked out successfully`);
      } else {
        setMessage(`Failed to check out job ${jobId}`);
        console.error(`Failed to check out job ${jobId}`);
      }
    } catch (error) {
      setMessage(`Error checking out job: ${error.message}`);
      console.error("Error checking out job:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-4 mt-3">
      <h3>Manually Check Out a Job</h3>
      <Form onSubmit={handleManualCheckout}>
        <Form.Group controlId="formJobId" className="mb-3">
          <Form.Label>Job ID</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Job ID"
            value={jobId}
            onChange={(e) => setJobId(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group controlId="formAssignedUser" className="mb-3">
          <Form.Label>Assigned User</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Assigned User"
            value={assignedUser}
            onChange={(e) => setAssignedUser(e.target.value)}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Check Out"}
        </Button>
      </Form>

      {message && <Alert className="mt-3" variant="info">{message}</Alert>}
    </div>
  );
}

export default AdminManualCheckout;
